import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword';
import Dashboard from './pages/Dashboard';
import Setup from './pages/Setup';
import Team from './pages/Team';
import Projects from './pages/Projects';
import ProjectDetails from './pages/ProjectDetails';
import Clients from './pages/Clients';
import KPIs from './pages/KPIs';
import Datasheets from './pages/Datasheets';
import References from './pages/References';
import ReferenceDetails from './pages/ReferenceDetails';
import Tickets from './pages/Tickets';
import TicketDetails from './pages/TicketDetails';
import Contracts from './pages/Contracts';
import ContractDetails from './pages/ContractDetails';
import Punching from './pages/Punching';
import PunchingDetails from './pages/PunchingDetails';
import ITProjects from './pages/ITProjects';
import ITProjectDetails from './pages/ITProjectDetails';
import SupportDashboard from './pages/SupportDashboard';
import Inbox from './pages/Inbox';
import InboxDetails from './pages/InboxDetails';
import ITSuppliers from './pages/ITSuppliers/ITSuppliers';
import ITSupplierDetails from './pages/ITSuppliers/ITSupplierDetails';
import SoftwareLicenses from './pages/SoftwareLicenses/SoftwareLicenses';
import SoftwareLicenseDetails from './pages/SoftwareLicenses/SoftwareLicenseDetails';
import Layout from './components/Layout';


function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));

  const setAuth = (token) => {
    localStorage.setItem('token', token);
    setToken(token);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
  };

  useEffect(() => {
    // Add a response interceptor
    const interceptor = axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response && error.response.status === 401) {
          logout();
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={!token ? <Login setAuth={setAuth} /> : <Navigate to="/" />} />
        <Route path="/change-password" element={<ChangePassword />} />
        {token ? (
          <Route element={<Layout logout={logout} />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/setup" element={<Setup />} />
            <Route path="/team" element={<Team />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<ProjectDetails />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/kpis" element={<KPIs />} />
            <Route path="/datasheets" element={<Datasheets />} />
            <Route path="/references" element={<References />} />
            <Route path="/references/:id" element={<ReferenceDetails />} />
            <Route path="/tickets" element={<Tickets />} />
            <Route path="/tickets/:id" element={<TicketDetails />} />
            <Route path="/contracts" element={<Contracts />} />
            <Route path="/contracts/:id" element={<ContractDetails />} />
            <Route path="/punching" element={<Punching />} />
            <Route path="/inbox" element={<Inbox />} />
            <Route path="/inbox/:id" element={<InboxDetails />} />

            <Route path="/it-suppliers" element={<ITSuppliers />} />
            <Route path="/it-suppliers/:id" element={<ITSupplierDetails />} />
            <Route path="/software-licenses" element={<SoftwareLicenses />} />
            <Route path="/software-licenses/:id" element={<SoftwareLicenseDetails />} />

            <Route path="/punching/:id" element={<PunchingDetails />} />
            <Route path="/it-projects" element={<ITProjects />} />
            <Route path="/it-projects/:id" element={<ITProjectDetails />} />
            <Route path="/support-dashboard" element={<SupportDashboard />} />
          </Route>
        ) : (
          <Route path="*" element={<Navigate to="/login" />} />
        )}
      </Routes>
    </Router>
  );
}

export default App;
